
<mat-card [ngClass]="{'add-device-null': deviceInfo === null}">
    <div *ngIf="deviceInfo === null" class="compare-tile-contents add-device compare-tile-bottom" onClick="document.getElementById('scrollToOnAddDevice').scrollIntoView();">

        <mat-card-title class="add-device">+ add device</mat-card-title> 

    </div>
    <div *ngIf="deviceInfo != null" class="compare-tile-contents">
        <div class="compare-tile-top">
            <div *ngIf="showInStockInfo" [ngClass]="{'in-stock': deviceInfo.primaryItem.isInStock, 'out-stock': !deviceInfo.primaryItem.isInStock}" class="stock">{{deviceInfo.primaryItem.isInStock ? 'In Stock' : 'Out of Stock'}}</div>
            <button (click)="onRemove()" class="close-button" aria-label="Dismiss alert" type="button" data-close>
                <span aria-hidden="true">&times;</span>
              </button>
 
            <img class="compare-tile-img" src="{{deviceInfo.primaryItem.imageLocation}}"/>

        </div>
        <div class="compare-tile-bottom">
            <mat-card-title>
                {{deviceInfo.primaryItem.productDescShort}}
            </mat-card-title>
        <mat-card-subtitle>
            <div class="compare-info">
                <img class="compare-icon" src="../../../../../../assets/images/processor.svg"/>
                <div>
                <p class="compare-info-label">{{ processorLabel }}</p>
                <p class="compare-info-data">{{deviceInfo.primaryItem.cpuModel === '' ? 'N/A' : deviceInfo.primaryItem.cpuModel}}</p>
                </div>
            </div>

            <div class="compare-info">
                <img class="compare-icon" src="../../../../../../assets/images/memory.svg"/>
                <div>
                <p class="compare-info-label">{{ memoryLabel }}</p>
                <p class="compare-info-data">{{deviceInfo.primaryItem.memorySize === undefined ? 'N/A' : deviceInfo.primaryItem.memorySize + deviceInfo.primaryItem.memoryUnit}}</p>
                </div>
            </div>

            <div class="compare-info">
                <img class="compare-icon" src="../../../../../../assets/images/storage.svg"/>
                <div>
                <p class="compare-info-label">{{ storageLabel }}</p>
                <p class="compare-info-data">{{deviceInfo.primaryItem.diskDriveSize === undefined ? 'N/A' : deviceInfo.primaryItem.diskDriveSize + deviceInfo.primaryItem.diskDriveType}}</p>
                </div>
            </div>

            <div class="compare-info">
                <img class="compare-icon" src="../../../../../../assets/images/laptop.svg"/>
                <div>
                <p class="compare-info-label">{{ displayLabel }}</p>
                <p class="compare-info-data">{{deviceInfo.primaryItem.screenSize === '' ? 'N/A' : deviceInfo.primaryItem.screenSize}}</p>
                </div>
            </div>
        </mat-card-subtitle>
        <div *ngIf="!showAddToCartButton" class="column" >
            <button
              class="learn-more-button"
              (click)="onLearnMore()"
              id="comparison_learn_more"
            >
              <span aria-hidden="true">{{ learnMoreButtonText }}</span>
            </button>
          </div>
          <div class="column" id="addToCartClick" *ngIf="showAddToCartButton">
            <form>
            <button
              *ngIf="showAddToCartButton"
              mat-flat-button
              class="secondary"
              (click)="addToCartClick(deviceInfo.primaryItem, itemQuantity.value)" type="submit"
            >ADD TO CART</button>
            <div class="quantityWrapper">
            <label style="margin-left: 10px; color: black !important;">QTY: </label>
            <input matInput id="itemQuantityInput" placeholder="1" value="1" type="number" min="1" max="99999" appearance="fill" #itemQuantity required>
            <h3 name="formQuantityError">{{formQuantityError}}</h3>
            </div>
            </form>
          </div>
        </div>
    </div>
</mat-card>
